import BASE_URL from "../../shared/base-url"

export const OWNER_ENDPOINT = {
  detail: `${BASE_URL}/owners/get-owner`,
  list: `${BASE_URL}/owners/get-owners`,
  archive: `${BASE_URL}/owners/archive-owner`,
  delete: `${BASE_URL}/owners/delete-owner`,
  toggleStatus: `${BASE_URL}/owners/activate-or-block-owner`,
  bulkToggleStatus: `${BASE_URL}/owners/bulk-activate-or-block-owner`,
  restore: `${BASE_URL}/owners/restore-owner`,
  archivedOwners: `${BASE_URL}/owners/get-archived-owners`,
  archivedOwner: `${BASE_URL}/owners/get-archived-owner`,
  create: `${BASE_URL}/owners/create-owner`,
  update: `${BASE_URL}/owners/update-owner`,
  updateProfile: `${BASE_URL}/owners/update-owner-profile-image/`,

  export: `${BASE_URL}/owners/export-owners`,
  payForOwnerManually: `${BASE_URL}/payments/pay-for-owners-manually`,

  getSettings: `${BASE_URL}/owners/get-owner-setting`,
  updateSettings: `${BASE_URL}/owners/update-setting`,
}
